export default __webpack_public_path__ + "static/media/top_icon_right.e50e5196.png";